import { render, staticRenderFns } from "./ProformasSummary.vue?vue&type=template&id=393005dc"
import script from "./ProformasSummary.vue?vue&type=script&lang=js"
export * from "./ProformasSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports